/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2020 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { observable, action } from "mobx";

class PinchZoomStore {
  @observable centerPageIndex = 0;
  @observable centerX = 0;
  @observable centerY = 0;
  @observable centerXRatio = 0;
  @observable centerYRatio = 0;
  @observable initialZoomLevel = 0;

  @action
  setCenterParameters({ centerPageIndex = 0, centerX = 0, centerY = 0, centerXRatio = 0, centerYRatio = 0 }) {
    this.centerPageIndex = centerPageIndex;
    this.centerX = centerX;
    this.centerY = centerY;
    this.centerXRatio = centerXRatio;
    this.centerYRatio = centerYRatio;
  }

  @action
  setInitialZoom(initialZoomLevel) {
    this.initialZoomLevel = initialZoomLevel;
  }
}

export { PinchZoomStore };
